import { render } from "./SupportingDocuments.vue?vue&type=template&id=43a2ca46&scoped=true"
import script from "./SupportingDocuments.vue?vue&type=script&lang=js"
export * from "./SupportingDocuments.vue?vue&type=script&lang=js"

import "./SupportingDocuments.vue?vue&type=style&index=0&id=43a2ca46&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43a2ca46"]])

export default __exports__